module.exports = MaterialUI.ListSubheader;